import { useContext } from 'react'
import NotificationsContext from '@/components/context/NotificationsContext'

const useNotifications = () => useContext(NotificationsContext)

export default useNotifications
